var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider-back"},[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-box"},[_c('div',{staticClass:"prop-up"}),_c('img',{staticClass:"circle",attrs:{"src":require("@/assets/img/circle.png"),"alt":""}})])
}]

export { render, staticRenderFns }